import React, { CSSProperties } from 'react';
import numeral from 'numeral';

interface BuildingProps {
  accessibilityFeatures: any
  constructionMaterials: any
  roof: any
  flooring: any
  detailListStyle: CSSProperties
  archStyle: any
  stories: any
  storiesTotal: any
  propertyType: any
  yearBuilt: any
  livingArea: any
}

const Building = ({accessibilityFeatures, constructionMaterials, roof, flooring, detailListStyle, archStyle, stories, storiesTotal, propertyType, yearBuilt, livingArea} : BuildingProps) => {
  
	let cm: any = [];
	let rf: any = [];
	let fl: any = [];
	let al: any = [];
	let as: any = [];

	if (constructionMaterials) {
		cm = constructionMaterials;
	}

	if (roof) {
		rf = roof;
	}

	if (flooring) {
		fl = flooring;
	}

	if (flooring) {
		al = flooring;
	}

	if (accessibilityFeatures) {
		as = accessibilityFeatures;
	}
  
	archStyle?.map((style: any) => {
		return as.push(style);
	});


	return (
		<React.Fragment>
			<p className="text-uppercase cc-font-weight--bold mb-1">
				<i className="fal fa-warehouse-alt me-2" />
        Building
			</p>
			<ul style={detailListStyle}>
				{archStyle && <li><span className="cc-font-weight--normal">Architecture:</span> {as.join(', ')}</li>}
				{stories && <li><span className="cc-font-weight--normal">Stories:</span> {stories}</li>}
				{storiesTotal && <li><span className="cc-font-weight--normal">Stories total:</span> {storiesTotal}</li>}
				{livingArea >= 0 && <li><span className="cc-font-weight--normal">Living area:</span> {numeral(livingArea).format()} sq. feet</li>}
				{propertyType && <li><span className="cc-font-weight--normal">Property type:</span> {propertyType}</li>}
				{accessibilityFeatures && <li><span className="cc-font-weight--normal">Accessibility:</span> {al.join(', ')}</li>}
				{yearBuilt && <li><span className="cc-font-weight--normal">Year built:</span> {yearBuilt}</li>}
				{flooring && <li><span className="cc-font-weight--normal">Flooring:</span> {fl.join(', ')}</li>}
				{roof && <li><span className="cc-font-weight--normal">Roof:</span> {rf.join(', ')}</li>}
				{constructionMaterials && <li><span className="cc-font-weight--normal">Construction Materials:</span>&nbsp;{cm.join(', ')}</li>}
			</ul>
		</React.Fragment>
	);
};

export default Building;